'use client';

import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
if (typeof window !== 'undefined') {
  if (process.env.NEXT_PUBLIC_POSTHOG_KEY && process.env.NEXT_PUBLIC_POSTHOG_HOST) {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: '/ingest',
      ui_host: 'https://eu.posthog.com',
      person_profiles: 'always',
      mask_all_text: false,
      mask_all_element_attributes: false,
      disable_session_recording: process.env.NODE_ENV === 'development',
      autocapture: process.env.NODE_ENV === 'production',
      capture_pageview: process.env.NODE_ENV === 'production',
      capture_performance: process.env.NODE_ENV === 'production'
    });
  }
}
export function PostHogAnalytics({
  children
}: {
  children: React.ReactNode;
}) {
  return <PostHogProvider client={posthog} data-sentry-element="PostHogProvider" data-sentry-component="PostHogAnalytics" data-sentry-source-file="posthog.tsx">{children}</PostHogProvider>;
}